var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.676 14a.86.86 0 00.657-.275l.047-.046L17.719 1.56A.825.825 0 0018 .918c0-.26-.09-.478-.27-.654A.918.918 0 0017.062 0a.86.86 0 00-.657.275L4.887 11.567 1.767 6.22a.995.995 0 00-.586-.425.933.933 0 00-.716.08.839.839 0 00-.434.551.948.948 0 00.094.712l3.73 6.38a.865.865 0 00.704.459c.03.015.07.023.117.023z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/svg/checkmark.svg";
export { SvgCheckmark as ReactComponent };